// import Vue from 'vue'
import consts from "@/consts"
import range from "lodash/range";
import {getApiProps, updateObjectByDiff} from "@/lib/lib";
// import {arraySplitIntoChunks} from "@/lib/lib";

const with_removed = {'force[with_removed]': 1}//String(process.env.VUE_APP_PACKAGE).includes('admin') ? {'force[with_removed]': 1} : {}
const changedField = 'updated_at';

const collator = new Intl.Collator();
const sortByName = function (a, b) {
    let cmp = collator.compare(a?.name_ || '', b?.name_ || '')
    if (cmp) {
        return cmp;
    }
    return a.id - b.id;
}

let _maintenanceInspectionsIndexCache = {arr: null, map: null}
function getMaintenanceInspectionsIndexMap(state) {
    if (_maintenanceInspectionsIndexCache.arr !== state.maintenanceInspections) {
        _maintenanceInspectionsIndexCache.map = new Map(state.maintenanceInspections.map((u, i) => [u.id, i]))
        _maintenanceInspectionsIndexCache.arr = state.maintenanceInspections
    }
    return _maintenanceInspectionsIndexCache.map
}

let _maintenanceInspectionFormsIndexCache = {arr: null, map: null}
function getMaintenanceInspectionFormsIndexMap(state) {
    if (_maintenanceInspectionFormsIndexCache.arr !== state.maintenanceInspectionForms) {
        _maintenanceInspectionFormsIndexCache.map = new Map(state.maintenanceInspectionForms.map((u, i) => [u.id, i]))
        _maintenanceInspectionFormsIndexCache.arr = state.maintenanceInspectionForms
    }
    return _maintenanceInspectionFormsIndexCache.map
}

export default {
    state: {
        maintenanceInspectionFormsFullLoad: false,
        maintenanceInspectionForms: [],

        maintenanceInspectionsFullLoad: false,
        maintenanceInspectionsLiteLoad: false,
        maintenanceInspections: [],
    },
    actions: {
        fetchMaintenanceInspections/*all*/({dispatch, getters}, args) {
            return new Promise((resolve, reject) => {
                if (!getters.getApiToken) {
                    return reject(false)
                }

                dispatch('setLastCall', {name: 'fetchMaintenanceInspections', args, time: Date.now() / 1000})

                const params = getApiProps('maintenance_inspections', args)
                this.$api.maintenanceinspections.getAll({...params, ...with_removed})
                    .then((response) => {
                        if (response.status < 400 && !response.data.error) {
                            resolve(response.data)
                        } else {
                            reject(response)
                        }
                    })
                    .catch((error) => {
                        reject(error)
                        console.error(error);
                    })
                    .finally(() => {
                        dispatch('setLastCall', {name: 'fetchMaintenanceInspections', args, inprogress: false})
                    });
            })
        },
        fetchMaintenanceInspectionsAllInit({/*dispatch,*/ commit, getters}) {
            return new Promise((resolve, reject) => {
                if (getters.isMaintenanceInspectionsLiteLoad) {
                    return resolve(getters.getMaintenanceInspections.length)
                }
                this.$api.init.getMaintenanceInspections()
                    .then((response) => {
                        if (response.status < 400 && response.data?.maintenance_inspections) {

                            commit('setMaintenanceInspections', response.data.maintenance_inspections)
                            commit('setMaintenanceInspectionsLiteLoad', true)

                            resolve(true)
                        } else {
                            reject(response)
                        }
                    })
                    .catch((error) => {
                        reject(error)
                        console.error(error);
                        //setTimeout(() => {
                        //    dispatch('fetchMaintenanceInspectionsAllInit', {})
                        //}, 60 * 1000)
                    })
            })
        },
        fetchMaintenanceInspectionsAllLite({dispatch, commit, getters}) {
            return new Promise((resolve, reject) => {
                if (getters.isMaintenanceInspectionsLiteLoad) {
                    return resolve(getters.getMaintenanceInspections.length)
                }
                dispatch('fetchMaintenanceInspections', {lite: true})
                    .then((data) => {
                        commit('updateMaintenanceInspections', data)
                        commit('setMaintenanceInspectionsLiteLoad', true)
                        resolve(data.length)
                    })
                    .catch((error) => {
                        reject(error)
                        console.error(error);
                        setTimeout(() => {
                            dispatch('fetchMaintenanceInspectionsAllLite', {})
                        }, 60 * 1000)
                    })
            })
        },
        fetchMaintenanceInspectionsAllPages({dispatch, commit, getters}, args) {
            //dispatch('setLastCall', {name: 'fetchMaintenanceInspectionsAll', args, time: Date.now() / 1000})
            dispatch('setLastCall', {name: 'fetchMaintenanceInspectionsChanged', args, time: Date.now() / 1000})

            return new Promise((resolve, reject) => {
                    if (!getters.getApiToken) {
                        return reject(null)
                    }
                    if (!getters.getMaintenanceInspections.length) {
                        return resolve([])
                    }

                    let pageSize = consts.querySettings.maintenance.pageSize
                    let items = getters.getMaintenanceInspections.length
                    let pages = Math.ceil( items / pageSize)
                    if(pages > 8) {
                        pageSize = Math.ceil(items / consts.querySettings.maxPages)
                        pages = Math.ceil(items / pageSize)
                    }
                    let fetch = range(pages).map(i => {
                        let page = i + 1;
                        return dispatch('fetchMaintenanceInspections', {page, 'page-size': pageSize, ...args})
                            .then((data) => {
                                commit('updateMaintenanceInspections', data)
                            })
                            .catch(() => {
                                dispatch('fetchMaintenanceInspections', {page, 'page-size': pageSize, ...args})
                            })
                    });
                    resolve(fetch)
                })
                .then((fetch) => {
                    return Promise.all(fetch)
                        .finally(() => {
                            if (fetch.length) commit('setMaintenanceInspectionsFullLoad', true)
                        })
                })
                .finally(() => {
                    //dispatch('setLastCall', {name: 'fetchMaintenanceInspectionsAll', args, inprogress: false})
                    dispatch('setLastCall', {name: 'fetchMaintenanceInspectionsChanged', args, inprogress: false})
                })
        },
        fetchMaintenanceInspectionsChanged({dispatch, commit, getters}, args) {
            if (!getters.getApiToken || !getters.isMaintenanceInspectionsFullLoad) {
                return Promise.resolve(null)
            }

            dispatch('setLastCall', {name: 'fetchMaintenanceInspectionsChanged', args, time: Date.now() / 1000})

            args = {...consts.querySettings.filter, ...args}
            return dispatch('fetchMaintenanceInspections', args)
                .then((data) => {
                    commit('updateMaintenanceInspections', data)
                    return dispatch('fetchMaintenanceInspections', {fields: 'id', expand: ''})
                })
                .then((data) => {
                    commit('filterMaintenanceInspections', data)
                })
                .finally(() => {
                    dispatch('setLastCall', {name: 'fetchMaintenanceInspectionsChanged', args, inprogress: false})
                });
        },

        fetchMaintenanceInspectionForms({dispatch, commit, getters}, args) {
            return new Promise((resolve, reject) => {
                if (!getters.getApiToken) {
                    return reject(false)
                }

                dispatch('setLastCall', {name: 'fetchMaintenanceInspectionForms', args, time: Date.now() / 1000})

                const params = getApiProps('maintenance_inspection_forms', args)
                this.$api.maintenanceinspectionforms.getAll({...params, ...with_removed})
                    .then((response) => {
                        commit('updateMaintenanceInspectionForms', response.data)
                        resolve(true)
                    })
                    .catch((error) => {
                        reject(false)
                        console.error(error);
                    })
                    .finally(() => {
                        dispatch('setLastCall', {name: 'fetchMaintenanceInspectionForms', args, inprogress: false})
                    });
            })
        },
        saveMaintenanceInspection({dispatch}, maintenanceInspection) {
            let fn = (maintenanceInspection.id) ? 'updateMaintenanceInspection' : 'createMaintenanceInspection'
            return dispatch(fn, maintenanceInspection);
        },
        createMaintenanceInspection({commit, dispatch}, maintenanceInspection) {
            return new Promise((resolve, reject) => {
                const params = getApiProps('maintenance_inspections')
                this.$api.maintenanceinspections.create(maintenanceInspection, params)
                    .then((response) => {
                        if (response.status < 400 && !response.data.error) {
                            commit('updateMaintenanceInspection', response.data)
                            dispatch('fetchMaintenanceInspectionsChanged')
                        }
                        resolve(response)
                    })
                    .catch((error) => {
                        console.error(error);
                        reject(error)
                    });
            })
        },
        updateMaintenanceInspection({commit, dispatch}, maintenanceInspection) {
            return new Promise((resolve, reject) => {
                const params = getApiProps('maintenance_inspections')
                this.$api.maintenanceinspections.update(maintenanceInspection.id, maintenanceInspection, params)
                    .then((response) => {
                        if (response.status < 400 && !response.data.error) {
                            commit('updateMaintenanceInspection', response.data)
                            dispatch('fetchMaintenanceInspectionsChanged')
                        }
                        resolve(response)
                    })
                    .catch((error) => {
                        console.error(error);
                        reject(error)
                    });
            })
        },
        deleteMaintenanceInspection({commit, dispatch}, id) {//remove
            return new Promise((resolve, reject) => {
                const params = getApiProps('maintenance_inspections')
                this.$api.maintenanceinspections.delete(id, {...params, ...with_removed})//remove
                    .then((response) => {
                        if (response.status < 400 && (!response.data || !response.data.error)) {
                            if (!response.data) commit('deleteMaintenanceInspection', id)
                            else commit('updateMaintenanceInspection', response.data)
                            dispatch('fetchMaintenanceInspectionsChanged')
                        }
                        resolve(response)
                    })
                    .catch((error) => {
                        console.error(error);
                        reject(error)
                    });
            })
        },
        removedMaintenanceInspection({commit, dispatch}, id) {
            return new Promise((resolve, reject) => {
                const params = getApiProps('maintenance_inspections')
                this.$api.maintenanceinspections.removed(id, params)
                    .then((response) => {
                        if (response.status < 400 && !response.data.error) {
                            commit('updateMaintenanceInspection', response.data)
                            dispatch('fetchMaintenanceInspectionsChanged')
                        }
                        resolve(response)
                    })
                    .catch((error) => {
                        console.error(error);
                        reject(error)
                    });
            })
        },
        restoreMaintenanceInspection({commit, dispatch}, id) {
            return new Promise((resolve, reject) => {
                const params = getApiProps('maintenance_inspections')
                this.$api.maintenanceinspections.restore(id, params)
                    .then((response) => {
                        if (response.status < 400 && !response.data.error) {
                            commit('updateMaintenanceInspection', response.data)
                            dispatch('fetchMaintenanceInspectionsChanged')
                        }
                        resolve(response)
                    })
                    .catch((error) => {
                        console.error(error);
                        reject(error)
                    });
            })
        },
    },
    mutations: {
        setMaintenanceInspectionsFullLoad(state, FullLoad) {
            state.maintenanceInspectionsFullLoad = state.maintenanceInspectionsFullLoad || FullLoad
        },
        setMaintenanceInspectionsLiteLoad(state, LitaLoad) {
            state.maintenanceInspectionsLiteLoad = state.maintenanceInspectionsLiteLoad || LitaLoad
        },

        setMaintenanceInspections(state, nMaintenanceInspections) {
            state.maintenanceInspections = nMaintenanceInspections
        },

        updateMaintenanceInspections(state, nMaintenanceInspections) {
            if (!state.maintenanceInspections.length) {
                nMaintenanceInspections = nMaintenanceInspections.map(u => {
                    if (u?.name) u.name_ = u.name.toLocaleLowerCase()
                    return u //Object.freeze(u)
                })
                nMaintenanceInspections.sort(sortByName)
                state.maintenanceInspections = nMaintenanceInspections
                // const chunks = arraySplitIntoChunks(nMaintenanceInspections)//.reverse();
                // const pushOnRenderTask = () => {
                //     if (chunks.length === 0) return;
                //     let chunk = chunks.pop();
                //     state.maintenanceInspections.push(...chunk);
                //     setTimeout(() => {
                //     requestAnimationFrame(pushOnRenderTask);
                //     }, 300)
                //     //this.$nextTick().then(() => pushOnRenderTask())
                // }
                // pushOnRenderTask();
                return true
            }

            const indexById = getMaintenanceInspectionsIndexMap(state)
            nMaintenanceInspections.forEach(function (nMaintenanceInspection) {
                if (nMaintenanceInspection?.name) nMaintenanceInspection.name_ = nMaintenanceInspection.name.toLocaleLowerCase()
                let i = indexById.has(nMaintenanceInspection.id) ? indexById.get(nMaintenanceInspection.id) : -1
                if (i < 0) {
                    indexById.set(nMaintenanceInspection.id, state.maintenanceInspections.length)
                    state.maintenanceInspections.push(nMaintenanceInspection) //(Object.freeze(nMaintenanceInspection))
                } else
                if (!state.maintenanceInspectionsFullLoad || state.maintenanceInspections[i][changedField] != nMaintenanceInspection[changedField]) {
                    updateObjectByDiff(state.maintenanceInspections[i], nMaintenanceInspection)
                    // delete nMaintenanceInspection.id
                    // nMaintenanceInspection = {...state.maintenanceInspections[i], ...nMaintenanceInspection}
                    // state.maintenanceInspections[i] = nMaintenanceInspection //Object.freeze(nMaintenanceInspection)
                }
            })

        },
        filterMaintenanceInspections(state, nMaintenanceInspections) {
            // let Ids = state.maintenanceInspections.map(u=> u.id)
            let nIds = new Set(nMaintenanceInspections.map(u => u.id))
            state.maintenanceInspections = state.maintenanceInspections.filter(u => nIds.has(u.id))
        },
        updateMaintenanceInspection(state, nMaintenanceInspection) {
            if (nMaintenanceInspection?.name) nMaintenanceInspection.name_ = nMaintenanceInspection.name.toLocaleLowerCase()
            let i = state.maintenanceInspections.findIndex(u => (u.id == nMaintenanceInspection.id))
            if (i < 0) {
                state.maintenanceInspections.push(nMaintenanceInspection) //(Object.freeze(nMaintenanceInspection))
            } else
            if (!state.maintenanceInspectionsFullLoad || state.maintenanceInspections[i][changedField] != nMaintenanceInspection[changedField]) {
                updateObjectByDiff(state.maintenanceInspections[i], nMaintenanceInspection)
                // delete nMaintenanceInspection.id
                // nMaintenanceInspection = {...state.maintenanceInspections[i], ...nMaintenanceInspection}
                // state.maintenanceInspections[i] = nMaintenanceInspection //Object.freeze(nMaintenanceInspection)
            }
        },
        deleteMaintenanceInspection(state, id) {
            let i = state.maintenanceInspections.findIndex(u => (u.id == id))
            if (i != -1) {
                state.maintenanceInspections.splice(i, 1)
            }
        },

        updateMaintenanceInspectionForms(state, nMaintenanceInspectionForms) {
            if (!state.maintenanceInspectionForms.length) {
                nMaintenanceInspectionForms = nMaintenanceInspectionForms.map(u => {
                    if (u?.name) u.name_ = u.name.toLocaleLowerCase()
                    return u //Object.freeze(u)
                })
                nMaintenanceInspectionForms.sort(sortByName)
                state.maintenanceInspectionForms = nMaintenanceInspectionForms
                return true
            }

            const indexById = getMaintenanceInspectionFormsIndexMap(state)
            nMaintenanceInspectionForms.forEach(function (nMaintenanceInspectionForm) {
                if (nMaintenanceInspectionForm?.name) nMaintenanceInspectionForm.name_ = nMaintenanceInspectionForm.name.toLocaleLowerCase()
                let i = indexById.has(nMaintenanceInspectionForm.id) ? indexById.get(nMaintenanceInspectionForm.id) : -1
                if (i < 0) {
                    indexById.set(nMaintenanceInspectionForm.id, state.maintenanceInspectionForms.length)
                    state.maintenanceInspectionForms.push(nMaintenanceInspectionForm) //(Object.freeze(nMaintenanceInspectionForm))
                } else
                if (!state.maintenanceInspectionFormsFullLoad || state.maintenanceInspectionForms[i][changedField] != nMaintenanceInspectionForm[changedField]) {
                    updateObjectByDiff(state.maintenanceInspectionForms[i], nMaintenanceInspectionForm)
                    // delete nMaintenanceInspectionForm.id
                    // nMaintenanceInspectionForm = {...state.maintenanceInspectionForms[i], ...nMaintenanceInspectionForm}
                    // state.maintenanceInspectionForms[i] = nMaintenanceInspectionForm //Object.freeze(nMaintenanceInspectionForm)
                }
            })

        },

        clearMaintenanceInspections(state, {unitId} = {}) {
            if (unitId) {
                state.maintenanceInspections = state.maintenanceInspections.filter(i => (i.unit_id || i.object_id) != unitId)
            } else {
                state.maintenanceInspections = []
                state.maintenanceInspectionsFullLoad = false
                state.maintenanceInspectionsLiteLoad = false
            }
        },
    },
    getters: {
        isMaintenanceInspectionsFullLoad(state) {
            return state.maintenanceInspectionsFullLoad
        },
        isMaintenanceInspectionsLiteLoad(state) {
            return state.maintenanceInspectionsLiteLoad
        },
        getMaintenanceInspections(state) {
            return state.maintenanceInspections
        },
        getMaintenanceInspectionsByIds(state) {
            return state.maintenanceInspections.reduce((maintenanceInspectionsByIds, maintenanceInspection) => {
                maintenanceInspectionsByIds[maintenanceInspection.id] = maintenanceInspection
                return maintenanceInspectionsByIds
            }, {})
        },
        getSortedMaintenanceInspectionsIds(state) {
            let maintenanceInspections = state.maintenanceInspections
            maintenanceInspections.sort(sortByName)
            return maintenanceInspections.map(u => u.id)
        },
        getMaintenanceInspectionForms(state) {
            return state.maintenanceInspectionForms
        },
        getMaintenanceInspectionFormsByIds(state) {
            return state.maintenanceInspectionForms.reduce((maintenanceInspectionFormsByIds, maintenanceInspectionForm) => {
                maintenanceInspectionFormsByIds[maintenanceInspectionForm.id] = maintenanceInspectionForm
                return maintenanceInspectionFormsByIds
            }, {})
        },
    }
}
